import React from "react";

import {blob2DataURL} from "@/services/download";
import http from "@/services/http";

/** do catch this method at all times !! */
export async function getImage2Url(apiUrl: string) {
    const response = await http.get(apiUrl); // do not catch this part.
    const blob = await response.blob();
    const dataUrl = await blob2DataURL(blob);

    return dataUrl;
}

interface IProtectedImageProps {
    alt?: string;
    height?: string;
    placeholder?: string;
    url: string;
    width?: string;
}

interface IProtectedImageState {
    image?: string;
    error?: JSX.Element;
}

class ProtectedImage extends React.PureComponent<
    IProtectedImageProps,
    IProtectedImageState
> {
    public readonly state: IProtectedImageState = {};

    public componentDidMount() {
        this.retrieve();
    }

    public render() {
        const {alt, height, placeholder, width} = this.props;
        const {image} = this.state;

        return (
            <img
                // className="pointer-cursor"
                // onClick={this.triggerUpload} maybe maximize
                alt={alt}
                placeholder={placeholder}
                src={image}
                style={{height, width}}
            />
        );
    }

    private async retrieve() {
        const {url} = this.props;

        try {
            const image = await getImage2Url(url);
            this.setState({image, error: undefined});
        } catch {
            this.setState({image: undefined, error: undefined});
        }
    }
}

export default ProtectedImage;
